import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { colors } from '../../utils/theme';
import { motion } from 'framer-motion';
import media from 'styled-media-query';

export const Card = styled(motion.div)`
  padding: 24px;
  border-radius: 4px;
  background: white;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);
  margin-top: 16px;
  margin-bottom: 24px;

  ${media.lessThan('small')`
    padding: 8px;
  `}
`;

export const ContentWrapper = styled.div`
  width: 100%;
  min-height: 80vh;
  display: flex;
  justify-content: center;
  padding-top: 64px;
`;

export const Content = styled.div`
  max-width: 768px;
  width: 100%;
  padding-left: 32px;
  padding-right: 32px;

  ${media.lessThan('small')`
    padding-left: 8px;
    padding-right: 8px;
 `}
`;

export const Step = styled(Typography)`
  font-weight: 600 !important;
  display: inline;
`;

export const StepWrapper = styled.div`
  border-bottom: 2px solid ${colors.lightGreen};
  padding-bottom: 4px;
  width: 90px;
`;

export const Tab = styled.div`
  height: 38px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid ${colors.black};
  font-weight: 600;
  color: ${colors.black};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &.selected {
    background: ${colors.black};
    color: white;
  }
`;
